import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Spinner from '../../components/UI/Spinner';
import SimpleSnackbar from '../../components/UI/SimpleSnackbar';
import LoginForm from '../../components/Forms/LoginForm';
import Aux from '../../hoc/NoParent';

import * as actions from '../../store/actions/index';

class Login extends Component {
    onSubmitHandler = (values) => {
        this.props.onAuth(values.username, values.password);
    }

    render() {
        const { isAuthenticated, loading, error } = this.props;

        // If we are already authenticated, redirect back to where we wanted to be
        if(isAuthenticated) return <Redirect to={this.props.authRedirectPath} />;

        // If we are loading, display a spinner
        if(loading) return <Spinner />;

        let errorMessage = null;

        if(error) {
            errorMessage ='Invalid username or password';
            if(error.response) {
                if(error.response?.data?.code === 401) {
                    errorMessage = 'Invalid username or password';
                }
                else if(error.response?.data?.code === 500) {
                    errorMessage = 'Unexpected server error';
                }
                else {
                    errorMessage = error.response.data.message;
                }
            }
        }
        
        return (
            <Aux>
                <LoginForm onSubmit={this.onSubmitHandler} />
                { error ? <SimpleSnackbar open message={ errorMessage } /> : null }
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.token !== null, 
        authRedirectPath: state.auth.authRedirectPath, 
        loading: state.auth.loading, 
        error: state.auth.error 
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAuth: (username, password) => dispatch(actions.auth(username, password))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);